import styles from './MedrecruitStats.module.scss';

export const MedrecruitStats = () => (
  <div className={styles.statsContainer}>
    <div className={styles.statsItem}>
      <p className={styles.statsHeader}>5000+</p>
      <p className={styles.statsSubText}>doctors placed every year</p>
    </div>
    <div className={styles.statsItem}>
      <p className={styles.statsHeader}>20+</p>
      <p className={styles.statsSubText}>years industry experience</p>
    </div>
    <div className={styles.statsItem}>
      <p className={styles.statsHeader}>3x</p>
      <p className={styles.statsSubText}>more jobs than the next agency</p>
    </div>
  </div>
);
